// Amplitude analytics is DISABLED (2026-10, security incident: PII was being sent).
// Every export is a no-op and nothing may be sent. Names and arities are kept so call sites stay untouched.
// See the "Amplitude analytics hard-disabled" row in docs/debts.md before re-enabling.
import { purgeAmplitudeStorage } from "./purge-amplitude-storage";

export const initializeAnalytics = () => {
  purgeAmplitudeStorage();
};

export const reset = async () => {};

export const setUserId = (_userId) => {};

export const setUserProperties = (_data) => {};

export const logEvent = async (_event, _properties) => {};

export const logEventClicked = (event, properties) => {
  logEvent(`${event}_clicked`, properties);
};

export const logEventViewed = (event, properties) => {
  logEvent(`${event}_viewed`, properties);
};

export const logEventClosed = (event, properties) => {
  logEvent(`${event}_closed`, properties);
};

export const logEventSubmitted = (event, properties) => {
  logEvent(`${event}_submitted`, properties);
};

export const logEventSelected = (event, properties) => {
  logEvent(`${event}_selected`, properties);
};

export const logEventFocused = (event, properties) => {
  logEvent(`${event}_focused`, properties);
};

export const logEventBlured = (event, properties) => {
  logEvent(`${event}_blured`, properties);
};
